<template>
    <van-popup
        :value.sync="userSelectVisible"
        round
        position="bottom"
        :style="{ height: '77%' }"
        @click-overlay="handleClosePopup"
        v-if="userSelectVisible"
    >
        <div class="user_select_wrap">
            <div class="user_select_wrap_title">
                <van-icon @click="handleClosePopup" name="arrow-left" />
                <span class="title">{{ userSelectTitle }}</span>
                <span class="confirm_text" @click="handleClickConfirmSelect">确定</span>
            </div>
            <div class="user_select_wrap_search">
                <van-search v-model="searchForm.keyword" placeholder="请输入" @search="onSearch" @clear="onSearch" />
            </div>
            <div class="user_select_content">
                <div class="user_select_content_scroll">
                    <!-- 带姓名索引的写法，现在数据没有索引 -->
                    <!-- <van-index-bar :index-list="indexList" @select="onSelect($event)" highlight-color="#2979ff">
                        <div class="list" v-for="list in userList">
                            <div class="top">
                                <van-index-anchor :index="list.title"></van-index-anchor>
                            </div>
                            <div class="bottom">
                                <ul>
                                    <li v-for="item in list.list" :key="item.uid" @click="handleClickItem(item)">
                                        <div>
                                            <span class="avatar_wrap">
                                                <img
                                                    :src="item.avatar ? item.avatar : defaultImg"
                                                    loading="lazy"
                                                    alt=""
                                                />
                                            </span>
                                            <span>{{ item.name }}</span>
                                        </div>
                                        <van-icon
                                            name="success"
                                            color="#2990F0"
                                            v-if="
                                                selectType == 'multiple' &&
                                                selectUserList.find((find) => find.uid == item.uid)
                                                    ? true
                                                    : false
                                            "
                                        />
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </van-index-bar> -->
                    <ul>
                        <li v-for="item in userList" :key="item.id" @click="handleClickItem(item)">
                            <div>
                                <span class="avatar_wrap">
                                    <img :src="item.avatar ? item.avatar : defaultImg" loading="lazy" alt="" />
                                </span>
                                <span>{{ item.name }}</span>
                            </div>
                            <van-icon
                                name="success"
                                color="#2990F0"
                                v-if="
                                    selectType == 'multiple' && selectUserList.find((find) => find.id == item.id)
                                        ? true
                                        : false
                                "
                            />
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </van-popup>
</template>

<script>
export default {
    name: "UserSelect",
    props: {
        userSelectTitle: {
            type: String,
            default: "",
        },
        userSelectVisible: {
            type: Boolean,
            default: false,
        },
        extraSearchForm: {
            type: Object,
            default: () => {},
        }, // 查询的时候携带的其它参数
        selectType: {
            type: String,
            default: "one", //单选还是多选 one 单选 multiple 多选
        },
        allUserList: {
            type: Array,
            default: () => [],
        }, // 可选择的人员列表
        selectedUser: {
            type: Array,
            default: () => [],
        },
        isShowDisabled: {
            type: Boolean,
            default: () => false
        }, // 是否显示人员禁用状态
    },
    data() {
        return {
            defaultImg: require("@/assets/images/default.jpg"),
            searchForm: {
                keyword: "",
            },
            userList: [],
            indexList: [],
            selectUserData: {},
            selectUserList: [],
            oneLoading: true,
        };
    },
    created() {
        this.selectUserData = {};
        this.selectUserList = [];
        this.getUserList();
    },
    methods: {
        handleClosePopup() {
            this.$emit("update:userSelectVisible", false);
            this.$emit("selectUserClose", false);
        },
        onSearch() {
            this.getUserList();
        },
        onSelect(event) {},
        handleClickItem(item) {
            // if (this.selectType == "one") {
            //     this.selectUserData = item;
            //     this.handleClickConfirmSelect();
            // } else {
            //     let index = this.selectUserList.findIndex((find) => find.uid == item.uid);
            //     if (index > -1) {
            //         this.selectUserList.splice(index, 1);
            //     } else {
            //         this.selectUserList.push(item);
            //     }
            // }
            if (this.selectType == "one") {
                this.selectUserData = item;
                this.handleClickConfirmSelect();
            } else {
                let index = this.selectUserList.findIndex((find) => find.id == item.id);
                if (index > -1) {
                    this.selectUserList.splice(index, 1);
                } else {
                    this.selectUserList.push(item);
                }
            }
        },
        handleClickConfirmSelect() {
            if (this.selectType == "one") {
                if (!this.selectUserData || !this.selectUserData.id) return this.$toast("请选择");
                this.$emit("selectUserData", this.selectUserData);
            } else {
                if (!this.selectUserList || this.selectUserList.length == 0) return this.$toast("请选择");
                this.$emit("selectUserData", this.selectUserList);
            }
            this.handleClosePopup();
        },
        getUserList() {
            this.$toast.loading({
                message: "加载中...",
                forbidClick: true,
            });
            // 模拟搜索，前端进行搜索
            let data = this.allUserList.filter((item) =>
                item.name.toLowerCase().includes(this.searchForm.keyword.toLowerCase())
            );
            this.userList = data;
            this.$toast.clear();
            if (this.oneLoading == true) {
                this.oneLoading = false;
                this.oneLoadingFunction();
            }
            // let indexList = [];
            // let userList = [];
            // data.forEach((item, key) => {
            //     if (item.list && item.list.length > 0) {
            //         indexList.push(item.title.toUpperCase());
            //         userList.push(item);
            //     }
            // });
            // this.userList = userList || [];
            // this.indexList = indexList;
            // this.$toast.clear();
            // if (this.oneLoading == true) {
            //     this.oneLoading = false;
            //     this.oneLoadingFunction();
            // }
        },
        oneLoadingFunction() {
            if (this.selectType == "multiple") {
                this.selectUserList = [];
                this.userList.forEach((item, key) => {
                    if (this.selectedUser.find((find) => find == item.id)) {
                        this.selectUserList.push(item);
                    }
                });

                // this.userList.forEach((item, key) => {
                //     item.list.forEach((list, index) => {
                //         if (this.selectedUser.find((find) => find == list.uid)) {
                //             this.selectUserList.push(list);
                //         }
                //     });
                // });
            } else {
                this.userList.forEach((item, key) => {
                    if (this.selectedUser.find((find) => find == item.id)) {
                        this.selectUserData = list;
                    }
                });
                // this.userList.forEach((item, key) => {
                //     item.list.forEach((list, index) => {
                //         if (this.selectedUser.find((find) => find == list.uid)) {
                //             this.selectUserData = list;
                //         }
                //     });
                // });
            }
        },
    },
};
</script>

<style lang="scss">
.user_select_wrap {
    height: 100%;
    display: flex;
    flex-direction: column;
    .user_select_wrap_title {
        flex-shrink: 0;
        padding: 0 16px;
        height: 48px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .van-icon-arrow-left {
            font-size: 24px;
            color: rgba(102, 102, 102, 1);
        }
        .title {
            font-size: 16px;
            font-weight: 700;
            letter-spacing: 0px;
            line-height: 24px;
            color: rgba(51, 51, 51, 1);
        }
        .confirm_text {
            font-size: 16px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 24px;
            color: rgba(41, 144, 240, 1);
        }
    }
    .user_select_wrap_search {
        z-index: 1000;
        background: #ffff;
        position: relative;
        .van-search {
            padding: 0 16px;
            .van-search__content {
                border-radius: 6px;
                background: rgba(255, 255, 255, 1);

                border: 1px solid rgba(217, 217, 217, 1);
            }
            .van-icon-search {
                font-size: 16px;
                color: rgba(51, 51, 51, 1);
            }
        }
    }
    .user_select_content {
        flex: 1;
        padding: 10px 0;
        position: relative;
        overflow: hidden;
        .user_select_content_scroll {
            overflow-y: auto;
            width: 100%;
            height: 100%;
        }
        ul {
            padding: 0 16px;
            li {
                padding: 8px 0;
                display: flex;
                align-items: center;
                gap: 12px;
                font-size: 14px;
                font-weight: 400;
                letter-spacing: 0px;
                line-height: 22px;
                color: rgba(51, 51, 51, 1);
                div {
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    flex: 1;
                }
                .avatar_wrap {
                    display: inline-block;
                    width: 28px;
                    height: 28px;
                    border-radius: 50%;
                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        border-radius: 50%;
                    }
                }

                &:active {
                    background-color: rgba(217, 217, 217, 0.2);
                }
            }
        }
    }
    .van-index-bar__sidebar {
        position: absolute;
    }
}
</style>
